import type { CollectionTemplateBlock } from '../types/cms';
import { EntryTitleBlock } from '../blocks/EntryTitleBlock';
import { EntryCoverImageBlock } from '../blocks/EntryCoverImageBlock';
import { EntryRichTextBlock } from '../blocks/EntryRichTextBlock';
import { EntryFieldBlock } from '../blocks/EntryFieldBlock';
import { CollectionEntriesGridBlock } from '../blocks/CollectionEntriesGridBlock';
import { CollectionEntriesListBlock } from '../blocks/CollectionEntriesListBlock';

function renderBlock(block: CollectionTemplateBlock): React.ReactNode {
  const props = block.props as Record<string, unknown>;
  const slug = block.blockSlug;

  switch (slug) {
    case 'entry-title':
      return <EntryTitleBlock key={block.id} tag={(props.tag as 'h1' | 'h2' | 'h3') ?? 'h1'} />;
    case 'entry-cover-image':
      return <EntryCoverImageBlock key={block.id} fieldKey={props.fieldKey as string | undefined} />;
    case 'entry-rich-text':
      return <EntryRichTextBlock key={block.id} fieldKey={props.fieldKey as string | undefined} />;
    case 'entry-field':
      return (
        <EntryFieldBlock
          key={block.id}
          fieldKey={(props.fieldKey as string) ?? ''}
          label={props.label as string | undefined}
        />
      );
    case 'collection-entries-grid':
      return (
        <CollectionEntriesGridBlock
          key={block.id}
          columns={props.columns as 2 | 3 | 4 | undefined}
          imageField={props.imageField as string | undefined}
          excerptField={props.excerptField as string | undefined}
        />
      );
    case 'collection-entries-list':
      return (
        <CollectionEntriesListBlock
          key={block.id}
          imageField={props.imageField as string | undefined}
        />
      );
    default:
      return null;
  }
}

export function TemplateBlockRenderer({ blocks }: { blocks: CollectionTemplateBlock[] }) {
  const rootBlocks = blocks
    .filter((b) => !b.parentBlockId)
    .sort((a, b) => a.sortOrder - b.sortOrder);
  return (
    <div className="max-w-2xl mx-auto space-y-6 py-8 px-4">
      {rootBlocks.map((block) => renderBlock(block))}
    </div>
  );
}
